import { Flex, Text } from "@chakra-ui/react";

export const FamilyName = ({ children, color = "mediumEmphasis", ...rest }) => (
  <Text
    fontSize={["13px", "21px", "25px"]}
    color="mediumEmphasis"
    fontWeight={500}
    textTransform="uppercase"
    {...rest}
  >
    {children}
  </Text>
);

export const Card = ({ children, ...rest }) => (
  <Flex
    width={["270px", "378px", "432px"]}
    minHeight={["312px", "438px", "500px"]}
    p={["0px 46px 16px 46px", "0px 64px 32px 64px", "0px 72px 36px 72px"]}
    wordBreak="break-all"
    flexDirection="column"
    borderRadius="10.2px"
    boxShadow="0 2px 5px -1px rgba(0, 0, 0, 0.12),0 1px 19px 0 rgba(0, 0, 0, 0.06), 0 5px 9px 0 rgba(0, 0, 0, 0.08)"
    {...rest}
  >
    {children}
  </Flex>
);
